import styled from "styled-components";
import LayoutModal from "../Layout/LayoutModal";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";

const AlarmCancelBox = ({ title, subtitle, handleCancel, handleClickX }) => {
  return (
    <Box>
      <div className="hrz-wrapper center">
        <p className="bold-text" style={{ fontSize: "20px" }}>
          {title}
        </p>
      </div>
      <div className="hrz-wrapper center" style={{ marginTop: "10px" }}>
        <p
          style={{
            color: "#222222",
            wordBreak: "break-all",
            whiteSpace: "pre-wrap",
            textAlign: "center",
          }}
        >
          {subtitle}
        </p>
      </div>

      <div className="hrz-wrapper" style={{ marginTop: "30px" }}>
        <div
          className="blueBorderBtn-base center"
          style={{
            width: "193px",
            height: "60px",
            borderRadius: "10px",
            fontFamily: "notoSans-medium",
          }}
          onClick={handleClickX}
        >
          취소
        </div>
        <div
          className="blueBtn-base center"
          style={{
            marginLeft: "14px",
            width: "193px",
            height: "60px",
            borderRadius: "10px",
            fontFamily: "notoSans-medium",
          }}
          onClick={handleCancel}
        >
          확인
        </div>
      </div>
    </Box>
  );
};

const AlarmCancel = ({ title, subtitle, handleCancel, handleClickX }) => {
  return (
    <LayoutModal
      Modal={
        <AlarmCancelBox
          title={title}
          subtitle={subtitle}
          handleCancel={handleCancel}
          handleClickX={handleClickX}
        />
      }
    />
  );
};

const Box = styled.div`
  padding: 30px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
`;

export default AlarmCancel;
